import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { history } from '../routers/AppRouter';
import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ROUTES from '../data/routes';
import { getAllTypeCoating, updateTypeCoating } from '../app/store/actions/typeCoating';
import ModalComponent from '../components/modal';

class TypeCoatingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 10,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listTypeCoating: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'description', value: I18n.t('description') },
      { key: 'createdAt', value: I18n.t('createdIn') },
      { key: 'updatedAt', value: I18n.t('changedIn') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getAllTypeCoating();
  }

  updateTypeCoatingStatus = async (parameters = {}) => {
    try {
      await this.props.updateTypeCoating({ ...parameters })

      await this.getAllTypeCoating();
    } catch (err) {

      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  adjustData = async (count = 0, rows = []) => {
    const listTypeCoating = rows.map((element, index) => ({
      key: index,
      id: element.id,
      description: element.description,
      createdAt: moment(element.createdAt).format('L LT'),
      updatedAt: moment(element.updatedAt).format('L LT'),
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${element.status ? 'warning' : 'dark'} promotion-btn-${element.status ? 'warning' : 'active'}`}
            onClick={() => this.updateTypeCoatingStatus({
              id: element.id,
              status: !element.status,
              description: element.description
            })}
          >
            {(element.status)
              ? I18n.t('disable')
              : I18n.t('active')
            }
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  history.push({
                    pathname: ROUTES.FORM,
                    screenComming: 'typeCoating',
                    selectedTypeCoating: element,
                  });
                }
                }
              >
                {I18n.t('edit')}
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      listTypeCoating,
    });
  }

  getAllTypeCoating = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getAllTypeCoating(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getAllTypeCoating();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getAllTypeCoating();
  }

  confirmModal = async () => {
    this.setState({ showModal: false });
  }

  tableButtons = () => (
    <React.Fragment>
      <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'typeCoating' }} />
    </React.Fragment>
  )

  render() {
    const {
      limit, page, listTypeCoating, totalRecord, titleModal, titleModalBody, showModal, showCancel,
    } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '400px', height: '250px' }}
          showButtons
          confirmModal={this.confirmModal}
        />
        <Table
          title={I18n.t('typeCoating')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={listTypeCoating}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAllTypeCoating: (limit, skip, search, orderBy, field) => dispatch(getAllTypeCoating(limit, skip, search, orderBy, field)),
  updateTypeCoating: (updTypeCoating) => dispatch(updateTypeCoating(updTypeCoating)),
});

const mapStateToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TypeCoatingPage);
